import React from 'react';
import { EditModeWrapper, OverlayContent, OverlayLink, HiddenTitle } from './EditMode.styles';
import Conditional from '../../../../components/Conditional/Conditional';
import { regularWhite } from '../../../design-tokens';
import PlayText, { TYPES } from '../../../typography/PlayText/PlayText';

const EditMode = ({ markedAsDeleted, programTitle }) => (
    <EditModeWrapper aria-live="polite">
        <Conditional condition={markedAsDeleted}>
            <OverlayContent type={TYPES.SMALL}>{programTitle} har tagits bort ur listan.</OverlayContent>
            <OverlayLink type={TYPES.MINI} underline>
                Ångra
            </OverlayLink>
        </Conditional>
        <Conditional condition={!markedAsDeleted}>
            <PlayText dataRt="delete-program-button" color={regularWhite} underline>
                Ta bort <HiddenTitle> : {programTitle}.</HiddenTitle>
            </PlayText>
        </Conditional>
    </EditModeWrapper>
);

export default EditMode;
